import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import noUrl from 'rise-ui/helpers/no-url.js';
import noUrlTarget from 'rise-ui/helpers/no-url-target.js';
import or from 'rise-ui/helpers/or.js';
import trustedHtml from 'rise-ui/helpers/trusted-html.js';

export default RouteTemplate(class FileGalleryTemplate extends Component {
  <template>
    {{pageTitle "File Gallery"}}

    {{#if @model.fileGallery.isPending~}}
      <div class="c-no-result qa-file-gallery-loading">
        File Gallery Loading...
      </div>
    {{else if @model.fileGallery.isRejected~}}
      <div class="c-no-result qa-file-gallery-error">
        File Gallery Not Found
      </div>
    {{else}}
      <h3 class="c-page-title qa-page-title">{{@model.fileGallery.title}}</h3>

      <div class="c-html-content">
        {{~trustedHtml @model.fileGallery.bodyProcessed~}}
      </div>

      <ul>
        {{#each @model.fileGallery.filesOrdered as | file |}}
          <li>
            <a href={{noUrl file.url}}
              role="button" target={{noUrlTarget file.url "_blank"}} rel="noopener noreferrer"
            >
              {{or file.description file.filename}}
            </a>
          </li>
        {{else}}
          <li>No Files</li>
        {{/each}}
      </ul>
    {{~/if}}

    {{outlet}}
  </template>
});
